<template>
  <div class="request-loading">
    <svg
      class="spinner"
      :width="getWidth"
      :height="getHeight"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="path"
        :class="colorRotator"
        fill="none"
        stroke-width="6"
        stroke-linecap="round"
        cx="33"
        cy="33"
        r="30"
      />
    </svg>
    <div
      v-if="showOverlay"
      class="overlay"
    />
  </div>
</template>
<script>
import _color from "./color";
export default {
  name: "RequestLoadingIndicator",
  props: {
    scale: {
      type: [String, Number],
      default: 1,
    },
    width: {
      type: [String, Number],
      default: "48px",
    },
    height: {
      type: [String, Number],
      default: "48px",
    },
    // có hiển thị cái background mờ mờ không
    showOverlay: {
      type: [Boolean],
      default: false,
    },
    colorRotator: {
      type: String,
      default: 'mixColor',
      validator(value) {
        // The value must match one of these strings
        return ['Green', 'Red', 'Black','mixColor','Blue','Grey'].includes(value)
      }
    }
  },
  data: () => ({}),
  computed: {
    getWidth() {
      if (typeof this.width == "string") {
        return this.width;
      } else {
        return this.width + "px";
      }
    },
    getHeight() {
      if (typeof this.height == "string") {
        return this.height;
      } else {
        return this.height + "px";
      }
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.fullScreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
.bg-transparent-loading .con-ms-loading {
  background: transparent;
}
.request-loading {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 7;
  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.4);
    z-index: 1;
  }
  svg{
    position: relative;
    z-index: 2;
  }
  @-webkit-keyframes rotator {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(270deg);
      transform: rotate(270deg);
    }
  }

  @keyframes rotator {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(270deg);
      transform: rotate(270deg);
    }
  }
  .path {
    stroke-dasharray: 187;
    stroke-dashoffset: 0;
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-animation: dash 1.4s ease-in-out infinite;
    animation: dash 1.4s ease-in-out infinite;
  }
  .mixColor{
    -webkit-animation: dash 1.4s ease-in-out infinite,
    colors 5.6s ease-in-out infinite;
    animation: dash 1.4s ease-in-out infinite,
    colors 5.6s ease-in-out infinite;
  }
  .Green{
    stroke: #1b9a59;
  }

  .Red{
    stroke: #de3e35;
  }

  .Black{
    stroke: black;
  }

  .Blue{
    stroke: #4285f4;
  }

  .Grey{
    stroke: #6b6969;
  }
  @-webkit-keyframes colors {
    0% {
      stroke: #4285f4;
    }
    25% {
      stroke: #de3e35;
    }
    50% {
      stroke: #f7c223;
    }
    75% {
      stroke: #1b9a59;
    }
    100% {
      stroke: #4285f4;
    }
  }

  @keyframes colors {
    0% {
      stroke: #4285f4;
    }
    25% {
      stroke: #de3e35;
    }
    50% {
      stroke: #f7c223;
    }
    75% {
      stroke: #1b9a59;
    }
    100% {
      stroke: #4285f4;
    }
  }
  @-webkit-keyframes dash {
    0% {
      stroke-dashoffset: 187;
    }
    50% {
      stroke-dashoffset: 46.75;
      -webkit-transform: rotate(135deg);
      transform: rotate(135deg);
    }
    100% {
      stroke-dashoffset: 187;
      -webkit-transform: rotate(450deg);
      transform: rotate(450deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dashoffset: 187;
    }
    50% {
      stroke-dashoffset: 46.75;
      -webkit-transform: rotate(135deg);
      transform: rotate(135deg);
    }
    100% {
      stroke-dashoffset: 187;
      -webkit-transform: rotate(450deg);
      transform: rotate(450deg);
    }
  }
}
</style>
